module.exports = __webpack_public_path__ + "img/2.19fe6780.jpg";